/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Admin_Allocation_Form_Plan_Info_Per_MonthsInputs */

const en_admin_allocation_form_plan_info_per_months = /** @type {(inputs: Admin_Allocation_Form_Plan_Info_Per_MonthsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} months`)
};

const de_admin_allocation_form_plan_info_per_months = /** @type {(inputs: Admin_Allocation_Form_Plan_Info_Per_MonthsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} Monate`)
};

const es_admin_allocation_form_plan_info_per_months = /** @type {(inputs: Admin_Allocation_Form_Plan_Info_Per_MonthsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} meses`)
};

const fr_admin_allocation_form_plan_info_per_months = /** @type {(inputs: Admin_Allocation_Form_Plan_Info_Per_MonthsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} mois`)
};

/** @type {(inputs: Admin_Allocation_Form_Plan_Info_Per_MonthsInputs) => LocalizedString} */
const it_admin_allocation_form_plan_info_per_months = en_admin_allocation_form_plan_info_per_months;

/** @type {(inputs: Admin_Allocation_Form_Plan_Info_Per_MonthsInputs) => LocalizedString} */
const pt_br2_admin_allocation_form_plan_info_per_months = en_admin_allocation_form_plan_info_per_months;

/** @type {(inputs: Admin_Allocation_Form_Plan_Info_Per_MonthsInputs) => LocalizedString} */
const pl_admin_allocation_form_plan_info_per_months = en_admin_allocation_form_plan_info_per_months;

/** @type {(inputs: Admin_Allocation_Form_Plan_Info_Per_MonthsInputs) => LocalizedString} */
const hu_admin_allocation_form_plan_info_per_months = en_admin_allocation_form_plan_info_per_months;

/** @type {(inputs: Admin_Allocation_Form_Plan_Info_Per_MonthsInputs) => LocalizedString} */
const ro_admin_allocation_form_plan_info_per_months = en_admin_allocation_form_plan_info_per_months;

/**
* | output |
* | --- |
* | "{count} months" |
*
* @param {Admin_Allocation_Form_Plan_Info_Per_MonthsInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_allocation_form_plan_info_per_months = /** @type {((inputs: Admin_Allocation_Form_Plan_Info_Per_MonthsInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Allocation_Form_Plan_Info_Per_MonthsInputs, { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_allocation_form_plan_info_per_months(inputs)
	if (locale === "de") return de_admin_allocation_form_plan_info_per_months(inputs)
	if (locale === "es") return es_admin_allocation_form_plan_info_per_months(inputs)
	if (locale === "fr") return fr_admin_allocation_form_plan_info_per_months(inputs)
	if (locale === "it") return it_admin_allocation_form_plan_info_per_months(inputs)
	if (locale === "pt-BR") return pt_br2_admin_allocation_form_plan_info_per_months(inputs)
	if (locale === "pl") return pl_admin_allocation_form_plan_info_per_months(inputs)
	if (locale === "hu") return hu_admin_allocation_form_plan_info_per_months(inputs)
	return ro_admin_allocation_form_plan_info_per_months(inputs)
});
export { admin_allocation_form_plan_info_per_months as "admin.allocation_form.plan_info_per_months" }